import { IUpdateLocationState, updateLocationActions } from "../../../state/updateLocation";
import { useDispatch, useSelector } from "react-redux";

import { ILocationItemResponse } from "../../../services/edit-hospital-location/edit-hospital-location.interface";
import { IRootState } from "../../../state";

export const useUpdateLocationStore = () => {
  const dispatch = useDispatch();
  const {
    locationSelected,
  } = useSelector((state: IRootState) => state.updateLocation as IUpdateLocationState);

  const setLocationSelected = (location: ILocationItemResponse[]) => {
    dispatch(updateLocationActions.setLocationSelected(location));
  };

  return {
    locationSelected,
    setLocationSelected,
  };
};
